const animate = (config: any) => {
  // Get elements with data-anim-group attrib
  const animationItems = document.querySelectorAll(
    `[data-anim-group="${config.name}"]`,
  )

  const getClassFromAttrib = (element: any) => {
    // Get value from data-anim attrib
    const className = element.getAttribute('data-anim')

    // Check if attrib value is empty string. If true return opacity animation as default
    if (className === '') return 'opacity'
    else return className
  }

  // Set up oberver options
  const options = config.options

  // Init observer
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      // Check if item is in viewport
      if (entry.isIntersecting) {
        if (entry.target.hasAttribute('data-anim')) {
          entry.target.classList.add(getClassFromAttrib(entry.target))
        }

        // Get all item children with data-anim attrib
        entry.target.querySelectorAll('[data-anim]').forEach((elem) => {
          if (elem.hasAttribute('data-slider')) {
            setTimeout(() => {
              elem.classList.remove(getClassFromAttrib(elem))
              elem.classList.remove(`${getClassFromAttrib(elem)}__before`)
            }, 3500)
          }

          // Add animation class
          elem.classList.add(getClassFromAttrib(elem))
          // Stop observing
          observer.unobserve(entry.target)
        })
      }
    })
  }, options)

  // Prepare elements before animation
  document.querySelectorAll('[data-anim]').forEach((elem) => {
    // Add animation class with __before
    elem.classList.add(`${getClassFromAttrib(elem)}__before`)
  })

  // Observe the animation groups to be placed in the viewport
  animationItems.forEach((item) => observer.observe(item))
}

export default animate
